import React from "react";
import { colors2 } from "oolib";
import { UI_CAPTION_DF } from "oolib/dist/v2/components/Typo2";

/**
 * A plain number: right-aligned, tabular digits, zero shown as 0 (not "–").
 *
 * `emphasis` marks the column that matters in a run of number columns — the
 * selected period in a drift table reads dark and semibold, the earlier
 * ones grey. `hint` goes on the title tooltip (e.g. the share of the period
 * this number is).
 */
const TableNumber = ({ value, emphasis = false, hint }) => {
  if (value === undefined || value === null) return null;
  return (
    <UI_CAPTION_DF
      title={hint || undefined}
      style={{
        display: "block",
        width: "100%",
        textAlign: "right",
        fontVariantNumeric: "tabular-nums",
        color: emphasis ? colors2.grey80 : colors2.grey50,
        fontWeight: emphasis ? 600 : 400,
      }}
    >
      {Number(value)}
    </UI_CAPTION_DF>
  );
};

export default TableNumber;
